module.exports = __webpack_public_path__ + "1792395595471/images/line-awesome.131b7f1.svg";